import { isEmpty, isNil } from 'ramda';

/**
 * Checks if value is nil, empty or NaN
 */
export default (v: any) => isNil(v) || isEmpty(v) || Number.isNaN(v);
